import { createSlice } from "@reduxjs/toolkit";
import { ipAddressAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const ipAddressSlice = createSlice({
  name: "ipAddress",
  initialState: data,
  reducers: {
    ipAddressSlice(state) {
      state.isLoading = false;
    },
    ipAddressSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    ipAddressSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    ipAddressSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const ipAddressHandler = (data:any) => async (dispatch: any) => {
  try {
    dispatch(ipAddressAction.ipAddressSlice());
    const response: any = await ipAddressAPI(data);
    dispatch(ipAddressAction.ipAddressSliceSuccess(response));
  } catch (e: any) {
    dispatch(ipAddressAction.ipAddressSliceFailure(e?.response?.data?.message));
    dispatch(ipAddressAction.ipAddressSliceReset());
  }
};
export default ipAddressSlice.reducer;
export const ipAddressAction = ipAddressSlice.actions;
